import { Component, inject } from '@angular/core';
import { TenantConfigService } from '../../../core/config/tenant-config';

@Component({
    selector: 'app-country',
    imports: [],
    templateUrl: './country.html',
    styleUrl: './country.scss',
})
export class Country {
    public tenantConfigService = inject(TenantConfigService);
    get settings() {
        return this.tenantConfigService.settings;
    }
}
